export enum LOCALES {
  DE = 'de',
  EN = 'en',
  PL = 'pl',
  UA = 'ua',
}
